<h1 class="visually-hidden" i18n>Videos</h1>

<my-videos-list
  #videosList

  *ngIf="account"

  [getVideosObservableFunction]="getVideosObservableFunction"
  [getSyndicationItemsFunction]="getSyndicationItemsFunction"

  [defaultSort]="defaultSort"

  displayFilters="true"
  [displayAsRow]="displayAsRow()"

  hideScopeFilter="true"

  loadUserVideoPreferences="true"

  highlightLives="true"

  [disabled]="disabled"
>
</my-videos-list>
